import {
    apiRequest,
    punishmentUpdate,
    punishmentDetail,
    punishmentListParent,
    punishmentListType,
    punishmentListSignatory
} from "../../../../../services/adapters/master/punishmentService"

class UpdateRepository {

    fetchUpdate = async (query) => {
        return await apiRequest("post", punishmentUpdate, {
            body: query
        }, true)
    }

    fetchDetail = async (query) => {
        return await apiRequest("get", punishmentDetail, {
            params: query
        }, true)
    }

    fetchSignatoryOfficial = async (query) => {
        return await apiRequest("get", punishmentListSignatory, {
            params: query
        }, true)
    }

    fetchParent = async (query) => {
        return await apiRequest("get", punishmentListParent, {
            params: query
        }, true)
    }

    fetchType = async (query) => {
        return await apiRequest("get", punishmentListType, {
            params: query
        }, true)
    }
}

export default UpdateRepository